import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { deleterDispatchHelper } from 'actions/DeleterActions';

import SimplePrompt from 'components/layout/SimplePrompt';
import TableResponsive from 'components/layout/TableResponsive';

import FormAutocomplete from 'components/forms/FormAutocomplete';

class ShareableResourceTeams extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };
  }

  show = () => {
    this.setState({ show: true });
  };

  addShare = (formPropertyName, shareWithId) => {
    if (shareWithId) {
      const { type, id, doShare } = this.props;
      doShare(type, id, shareWithId);
    }

    this.setState({ show: false });
  };

  removeShare = (e, shareWithId) => {
    e.preventDefault();
    e.stopPropagation();

    const { type, id, doRemoveShare } = this.props;
    doRemoveShare(type, id, shareWithId);
  };

  render() {
    const {
      intl: { messages },
      list,
      mayShare,
      mayRemove,
    } = this.props;
    const { show } = this.state;

    const headers = {
      team: messages.team,
      actions: messages.actions,
    };
    const rows = [];
    for (let i = 0; i < list.length; i++) {
      const rowData = {
        team: list[i].name,
        actions: mayRemove
          ? [
              <SimplePrompt
                key="remove"
                iconClass="fal fa-times"
                buttonLabel={messages.remove_selection}
                onSuccess={e => this.removeShare(e, list[i].id)}
              />,
            ]
          : [],
      };

      rows.push(rowData);
    }

    return (
      <div className="clearfix m-t-20">
        {mayShare && (
          <>
            <AnimateHeight duration={500} height={show ? 'auto' : 0}>
              <div className="form-group-attached">
                <FormAutocomplete label={messages.share_with} onChange={this.addShare} autocompleteType="team" />
              </div>
            </AnimateHeight>
            <AnimateHeight duration={500} height={!show ? 'auto' : 0}>
              <div className="text-center">
                <Button className="btn-rounded" onClick={this.show}>
                  <i className="fa fa-plus" />
                </Button>
              </div>
            </AnimateHeight>
          </>
        )}

        <div className="m-t-15">
          <TableResponsive headers={headers} rows={rows} hover />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    doShare: (type, id, shareWithId) => {
      const args = {
        shareWithType: 'team',
        shareWithId,
      };
      formStatusDispatchHelper('share', `/api/sharedresources/${type}/${id}.json`, args, 'post', dispatch);
    },
    doRemoveShare: (type, id, shareWithId) => {
      deleterDispatchHelper('share', `/api/sharedresources/${type}/${id}/team/${shareWithId}.json`, dispatch);
    },
  };
};

export default injectIntl(
  connect(
    null,
    mapDispatchToProps
  )(ShareableResourceTeams)
);
